import {
    SAVE_RESTAURANT,
    FETCH_MENU,
    SAVE_MENU_CATEGORY,
    DELETE_MENU_CATEGORY,
    SAVE_MENU_ITEM,
    DELETE_MENU_ITEM,
    DELETE_MENU_OVERRIDE,
    UPDATE_MENU_EDIT_INFO,
    FETCH_RESTAURANT_MENU_TRANSLATIONS,
    PREPARE_MENU
} from '../types';
import api from '../api';

let lastMenuRefresh = null;

export const createMenu = (restId) => {
    return {
        type: SAVE_RESTAURANT,
        payload: api.menus.create(restId, `Created for restaurant ${restId}`),
        meta: { restId, toastSuccess: true }
    };
};

export const importMenu = (menuId, restId) => {
    return {
        type: FETCH_MENU,
        payload: api.menus.clone(menuId, restId),
        meta: {
            toastSuccess: true,
            dispatchOnSuccess: (result => ({
                type: SAVE_RESTAURANT,
                payload: { menuId: result.menuId },
                meta: { restId }
            }))
        }
    };
};

export const fetchMenu = (menuId, branchIdForOverride, preventLoading = false) => {
    lastMenuRefresh = new Date();
    return {
        type: FETCH_MENU,
        payload: api.menus.get(menuId, branchIdForOverride).getFull(),
        meta: { preventLoading }
    };
};

export const prepareMenu = (menuId, branchIdForOverride, timezone) => {
    return {
        type: PREPARE_MENU,
        payload: api.menus.get(menuId, branchIdForOverride).prepare(timezone)
    };
};

export const saveMenuCategory = (menuId, branchIdForOverride, category, skipAPI = false, onSuccess) => {
    if (category.id) {
        return {
            type: SAVE_MENU_CATEGORY,
            payload: skipAPI ? category : api.menus.get(menuId, branchIdForOverride).categories.update(category),
            meta: { categoryId: category.id, onSuccess, dispatchOnSuccess: () => signEdit(menuId) }
        };
    } else {
        return {
            type: SAVE_MENU_CATEGORY,
            payload: skipAPI ? category : api.menus.get(menuId, branchIdForOverride).categories.create(category),
            meta: { toastSuccess: true, onSuccess, dispatchOnSuccess: () => signEdit(menuId), allowRequestDuplication: true }
        };
    }
};

export const deleteMenuCategory = (menuId, branchIdForOverride, categoryId) => {
    return {
        type: DELETE_MENU_CATEGORY,
        payload: api.menus.get(menuId, branchIdForOverride).categories.delete(categoryId),
        meta: { categoryId, dispatchOnSuccess: () => signEdit(menuId) }
    };
};

export const saveMenuItem = (menuId, branchIdForOverride, item, onSuccess) => {
    if (item.id) {
        return {
            type: SAVE_MENU_ITEM,
            payload: api.menus.get(menuId, branchIdForOverride).items.update(item),
            meta: { itemId: item.id, onSuccess, dispatchOnSuccess: () => signEdit(menuId) }
        };
    } else {
        return {
            type: SAVE_MENU_ITEM,
            payload: api.menus.get(menuId, branchIdForOverride).items.create(item),
            meta: { toastSuccess: true, onSuccess, dispatchOnSuccess: () => signEdit(menuId) }
        };
    }
};

export const deleteMenuItem = (menuId, itemId) => {
    return {
        type: DELETE_MENU_ITEM,
        payload: api.menus.get(menuId).items.delete(itemId),
        meta: { itemId, dispatchOnSuccess: () => signEdit(menuId) },
    };
};

export const fetchRestaurantMenuTranslations = (menuId) => {
    return {
        type: FETCH_RESTAURANT_MENU_TRANSLATIONS,
        payload: api.menus.get(menuId).getTranslations(),
    };
};

export const updateRestaurantMenuTranslations = (menuId, updates, onSuccess) => {
    return {
        type: FETCH_RESTAURANT_MENU_TRANSLATIONS,
        payload: api.menus.get(menuId).updateTranslations(updates),
        meta: { onSuccess }
    };
};

export const initRestaurantMenuTranslations = (menuId, languages) => {
    return {
        type: FETCH_RESTAURANT_MENU_TRANSLATIONS,
        payload: api.menus.get(menuId).initTranslations(languages),
    };
};

export const signEdit = (menuId) => {
    return {
        type: UPDATE_MENU_EDIT_INFO,
        payload: api.menus.get(menuId).editInfo(lastMenuRefresh),
        meta: { preventLoading: true }
    };
};

export const deleteOverrides = (menuId, branchId, entityType, entityId) => {
    return {
        type: DELETE_MENU_OVERRIDE,
        payload: api.menus.get(menuId).overrides.delete(branchId, entityType, entityId),
        meta: { 
            dispatchOnSuccess: () => fetchMenu(menuId, branchId)
         }
    };
};
